const replacer = (match) => `-${match.toLowerCase()}`;

const toSnakeCase = (str) => str.replace(/([A-Z].)/g, replacer);

export const propsToClassValues = (props, propTypes) => {
    const propKeys = propTypes;

    return Object.entries(props)
        .filter(([key]) => propKeys.includes(key))
        .reduce(
            (classes, [key, value]) => ({
                ...classes,
                [toSnakeCase(key)]: typeof value === 'number' ? String(value) : value,
            }),
            {}
        );
};

export const propsWithoutGridValues = (props, propTypes) => {
    const propKeys = propTypes;

    return Object.entries(props)
        .filter(([key]) => !propKeys.includes(key))
        .reduce(
            (_props, [key, value]) => ({
                ..._props,
                [key]: value,
            }),
            {}
        );
};
